import request from '@/utils/request'
// 获取国家列表
export function getCountryList () {
  return request({
    url: '/public/getCountry',
    method: 'get'
  })
}
// 获取经销商
export function getDealerList () {
  return request({
    url: '/public/getSupplier',
    method: 'get'
  })
}
// 提交经销商信息
export function submitDealerInfo (data) {
  return request({
    url: '/public/supplierSubmit',
    method: 'post',
    data
  })
}